import { render, staticRenderFns } from "./OwnerCreation.vue?vue&type=template&id=7f8ffeb4&scoped=true&"
import script from "./OwnerCreation.vue?vue&type=script&lang=js&"
export * from "./OwnerCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8ffeb4",
  null
  
)

export default component.exports